import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from 'App';
import 'focus-visible';
import 'polyfill-array-includes';
import { setupCharts } from 'styles';

// CSS Imports
import 'react-datepicker/dist/react-datepicker.css';
import 'styles/react-datepicker-overrides.css';
import 'tippy.js/dist/tippy.css';
import 'styles/tippy-overrides.css';
import 'draft-js/dist/Draft.css';
import 'draft-js-mention-plugin/lib/plugin.css';
import 'emoji-mart/css/emoji-mart.css';
import './index-build.css';

const Raven = window['Raven'];
const FS = window['FS'];

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://75d45fafd17f4dc581741f39f66280ef@o156813.ingest.sentry.io/1229104',
    integrations: [],
  });
}

// TODO: make this use @sentry/react instead of Raven which isn't being loaded
if (FS && Raven) {
  window['_fs_ready'] = function () {
    const sessionUrl = FS.getCurrentSessionURL();
    Raven.setUserContext({
      ...Raven.getContext().user,
      fullstorySession: sessionUrl || 'N/A',
    });
  };
}

// Init Chargebee
const Chargebee = (window as any).Chargebee;
if (Chargebee) {
  (window as any).Chargebee.init({
    site: process.env.REACT_APP_CHARGEBEE_SITE,
    publishableKey: process.env.REACT_APP_CHARGEBEE_PUBLISHABLE_KEY,
  });
}

setupCharts();

const rootEl = document.getElementById('root') as HTMLElement;

declare global {
  interface Window {
    Socialie: { tempUserToken?: string };
  }
}

window.Socialie = window.Socialie || {};

ReactDOM.render(<App />, rootEl);
